import React, { useRef, Children } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { ShieldIcon, FlameIcon, ZapIcon } from 'lucide-react';
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15,
      delayChildren: 0.2
    }
  }
};
const cardVariants = {
  hidden: {
    opacity: 0,
    y: 30
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
      ease: [0.25, 0.46, 0.45, 0.94]
    }
  }
};
export function ProblemSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="w-full bg-dark-bg py-20 md:py-28" data-id="element-307">
      <div className="max-w-4xl mx-auto px-6" data-id="element-308">
        {/* Section headline */}
        <motion.h2 className="font-bebas text-4xl md:text-5xl lg:text-6xl text-white text-center mb-16 tracking-wide" initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 20
      }} transition={{
        duration: 0.6
      }} data-id="element-309">
          YOUR SAFE IS A <span className="text-orange-accent" data-id="element-310">NEON SIGN</span>{' '}
          FOR THIEVES
        </motion.h2>

        {/* Problem cards */}
        <motion.div className="grid grid-cols-1 md:grid-cols-3 gap-6" variants={containerVariants} initial="hidden" animate={isInView ? 'visible' : 'hidden'} data-id="element-311">
          {/* Card 1 - Visibility */}
          <motion.div variants={cardVariants} className="bg-dark-card p-6 md:p-8 border border-white/5" data-id="element-312">
            <div className="w-12 h-12 flex items-center justify-center bg-orange-accent/10 border border-orange-accent/30 mb-6" data-id="element-313">
              <ShieldIcon className="w-6 h-6 text-orange-accent" data-id="element-314" />
            </div>
            <h3 className="font-bebas text-2xl text-white mb-3 tracking-wide" data-id="element-315">
              THE VISIBILITY PROBLEM
            </h3>
            <p className="font-inter text-concrete leading-relaxed" data-id="element-316">
              A 600lb safe delivered to your door tells every neighbor — and
              every thief — exactly what you own.
            </p>
          </motion.div>

          {/* Card 2 - Fire */}
          <motion.div variants={cardVariants} className="bg-dark-card p-6 md:p-8 border border-white/5" data-id="element-317">
            <div className="w-12 h-12 flex items-center justify-center bg-orange-accent/10 border border-orange-accent/30 mb-6" data-id="element-318">
              <FlameIcon className="w-6 h-6 text-orange-accent" data-id="element-319" />
            </div>
            <h3 className="font-bebas text-2xl text-white mb-3 tracking-wide" data-id="element-320">
              THE FIRE MYTH
            </h3>
            <p className="font-inter text-concrete leading-relaxed" data-id="element-321">
              Most "fire-rated" safes become ovens at real house fire temps.
              Your optics and ammo cook inside.
            </p>
          </motion.div>

          {/* Card 3 - Grinder */}
          <motion.div variants={cardVariants} className="bg-dark-card p-6 md:p-8 border border-white/5" data-id="element-322">
            <div className="w-12 h-12 flex items-center justify-center bg-orange-accent/10 border border-orange-accent/30 mb-6" data-id="element-323">
              <ZapIcon className="w-6 h-6 text-orange-accent" data-id="element-324" />
            </div>
            <h3 className="font-bebas text-2xl text-white mb-3 tracking-wide" data-id="element-325">
              THE $40 GRINDER PROBLEM
            </h3>
            <p className="font-inter text-concrete leading-relaxed" data-id="element-326">
              A cordless angle grinder defeats most retail safes in under 10
              minutes. You paid $3,000 for 10 minutes of security.
            </p>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}